const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  buttonBase: {
    display: 'block',
    marginBottom: 16,
    paddingBottom: 8
  },
  lockedSwitch: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  healthIconWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    paddingTop: 8,
  },
  healthIcon: {
    cursor: 'pointer',
  },
  linkedAssetsCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
    padding: 0
  },
  linkedAssetItem: {
    lineHeight: 1.2
  },
  bodyScroll: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  tableRegion: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& .ReactTable': {
      flex: '1 1 auto',
      minHeight: 0,
      height: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    '& .ReactTable .rt-table': {
      flex: '1 1 auto',
      minHeight: 0,
      overflow: 'hidden',
      marginBottom: 0
    },
    '& .ReactTable .rt-thead': {
      flex: '0 0 auto',
      background: '#fff'
    },
    '& .ReactTable .rt-thead .rt-th, & .ReactTable .rt-thead .rt-td': {
      background: '#fff',
      backgroundClip: 'padding-box'
    },
    '& .ReactTable .rt-tbody': {
      padding: '0 !important',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    '& .ReactTable .rt-tbody .rt-tr-group': {
      flex: '0 0 auto'
    },
    '& .ReactTable .rt-tbody .rt-tr': {
      flex: '0 0 auto'
    },
    '& .ReactTable .rt-td': {
      lineHeight: '1.4 !important',
      padding: '8px 6px !important'
    },
    '& .ReactTable .rt-td a': {
      lineHeight: '1.4 !important'
    },
    '& .ReactTable .rt-td p': {
      lineHeight: '1.4 !important'
    },
    '& .ReactTable .-pagination': {
      position: 'relative',
      flex: '0 0 auto',
      width: '100%',
      marginBottom: 0,
      backgroundColor: '#fff'
    }
  },
  button: {
    margin: theme.spacing.unit,
    background: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
})

export default styles
